import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import ContractDetailMainPage from "./pages/ContractDetailMainPage";
import ContractsSection from "./sections/ContractsSection";

export interface IContractsProps {
  type: string;
}

const Contracts: React.FC<IContractsProps> = (props) => {
  let match = useRouteMatch();

  // translations
  const { t } = useTranslation(["shared\\moduleNames"]);

  return (
    <Switch>
      <Route path={`${match.path}/:id`} component={ContractDetailMainPage} />
      <Route path={match.path}>
        <Header title={t("contracts.title")} includeBreadcrumbs />
        <ModuleContent>
          <ContractsSection />
        </ModuleContent>
      </Route>
    </Switch>
  );
};

export default Contracts;
